// 3rd-party modules
import { message } from 'antd';
import moment from 'moment-timezone';
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import dayjs, { Dayjs } from 'dayjs';
import { TimePicker as AntTimePicker, TimePickerProps as AntTimePickerProps } from "antd";

// project modules
import { apiCall } from "../../../helpers/apiHelper";
import { convertToSnakecase } from '../../../helpers/objectHelper';
import Input, { InputType } from '../../shared/inputs/input';
import Loader from "../../shared/loader";
import OptionBar from '../../shared/optionBar';
import Checkbox, { CheckboxType } from '../../shared/inputs/checkbox';
import Popup from '../../shared/popup/popup';
// import { TimePicker } from '../../../../components/shared/inputs/timePicker';
import yup from "../../../plugins/yup";
import { CONSTANTS } from '../../../helpers/defines';

// apis
import * as DashApi from '../../../apis/dashApi';

// models
import { Account } from '../../../models/account';
import { AccountDeviceSchedule } from '../../../models/accountDevice';
import { ApiResponse } from "../../../models/response";
import { accountDeviceScheduleInsertViewModel } from '../../../models/types/accountDeviceSchedule';
import { accountBlockedSiteViewModel } from '../../../models/types/accountBlockedSite';

type Props = {
  closeOnSave?: boolean;
  filterId?: string;
  filterSetId?: any;
  modalTitle?: string;
  open: boolean;
  account: Account;
  accountDeviceSchedule: AccountDeviceSchedule;
  deviceReference: string;
  kiboshDeviceReference: string;
  onClose?: () => void;
  onSave?: (accountDeviceSchedule: any) => void;
};

export default function AccountInternetScheduleModal({ closeOnSave = false, modalTitle = "", open, account, filterId = "", filterSetId = "", accountDeviceSchedule, deviceReference, kiboshDeviceReference, onClose, onSave }: Props) {
  //const schema = yup.object().shape({
  //  fromTime: yup.string().label("From Time").max(20).required(),
  //  toTime: yup.string().label("To Time").max(20).required()
  //});
  //const { control, handleSubmit } = useForm<AccountDeviceSchedule | any>({
  //  resolver: yupResolver(schema),
  //});
  const [loading, setLoading] = useState(false);
  const [repeatingDays, setRepeatingDays] = useState<string[]>([]);
  const [fromTime, setFromTime]           = useState<Dayjs|null>( null  );
  const [toTime, setToTime]               = useState<Dayjs|null>( null  );
  const abortController = new AbortController();


  useEffect(() => {
    if (open) {

      let sched = accountDeviceSchedule
      if(sched == null || sched.activeDays == null || sched.activeDays == "" || sched.activeDays == "all") {
        //setRepeatingDays(["mon","tue","wed","thu","fri","sat","sun"])
        setRepeatingDays([])
      } else {
        setRepeatingDays(sched.activeDays.split(/[,\t ]+/g))
      }
      if(sched != null && sched.fromHour != null ) {
        setFromTime( dayjs( "2025-09-01 " + sched.fromHour + ":" + zeroPad(sched.fromMinute) + " " + sched.fromAmPm ))
        setToTime(   dayjs( "2025-09-01 " + sched.toHour   + ":" + zeroPad(sched.toMinute)   + " " + sched.toAmPm ))
      } else {
        setFromTime( null )
        setToTime(   null )
      }
    }

  }, [open]);

  useEffect(() => {
  }, []);

  const zeroPad = (i:any) => { 
    return ("" + i).length == 1 ? "0" + i : "" + i 
  };

  const onCancel = () => {
    abortController.abort();

    if(onClose) onClose();
  };

  const onDaySelectionChange = (event: any, value: any) => {
    if (repeatingDays.includes(value)) {
      setRepeatingDays(repeatingDays.filter(x => x !== value));
    } else {
      setRepeatingDays([...repeatingDays, value]);
    }
  }

  const onSubmit = async () => {
    let response: ApiResponse;

    if (!repeatingDays.length) {
      message.error("Please select at least one day.")
      return;
    }

    setLoading(true);

    const tempData: accountDeviceScheduleInsertViewModel = {
      id: accountDeviceSchedule == null || accountDeviceSchedule.id == null ? undefined : accountDeviceSchedule?.id,
      fromAmPm: "",
      fromDay: undefined,
      fromHour: "",
      fromMinute: "",
      enabled: accountDeviceSchedule == null || accountDeviceSchedule.enabled == null || (!accountDeviceSchedule.enabled) ? "0" : "1",
      toAmPm: "",
      toDay: undefined,
      activeDays: repeatingDays.join(","),
      toHour: "",
      toMinute: "",
      repeats: "daily",
      kiboshDeviceReference: kiboshDeviceReference,
      deviceId: deviceReference,
      filterId: filterId?.toString()
    };

    if(fromTime != null && toTime != null) {
      tempData.fromHour = fromTime.format("hh");
      tempData.fromMinute = fromTime.format("mm");
      tempData.fromAmPm = fromTime.format("a");
      tempData.toHour = toTime.format("hh");
      tempData.toMinute = toTime.format("mm");
      tempData.toAmPm = toTime.format("a");
    }

    const data = convertToSnakecase(tempData, [], ["kiboshDeviceReference", "deviceId", "filterId"]);

    if (!accountDeviceSchedule?.id) {
      if (!filterId && filterSetId) { // in this case we should create a filter with list of schedules
        const filterTempData: accountBlockedSiteViewModel = {
          matchType: "set",
          deviceId: deviceReference,
          kiboshDeviceReference: kiboshDeviceReference,
          match: filterSetId,
          schedule: [data]
        }
        const filterData = convertToSnakecase(filterTempData, [], ["kiboshDeviceReference", "deviceId"]);

        response = await apiCall(DashApi.insertClientDeviceFilter(kiboshDeviceReference, deviceReference, filterData, abortController.signal));
      } else {
        response = await apiCall(DashApi.insertDeviceSchedule(deviceReference, data, abortController.signal));
      }
    }
    else
      response = await apiCall(DashApi.updateDeviceSchedule(accountDeviceSchedule?.id, data, abortController.signal));

    if (response.success) {
      message.success(`Internet Schedule ${!accountDeviceSchedule?.id ? 'added' : 'edited'} successfully.`);

      if (onSave) onSave(AccountDeviceSchedule.toClass(response.data?.value));

      if (closeOnSave) {
        open = false;

        onCancel();
      }

    } else
      message.error(response.error?.value);

    setLoading(false);
  };

  const dayIsActive = (day:string):boolean => { 
      return repeatingDays.includes(day)
  }




  return (
    <Popup
      title={ modalTitle || `Account: ${account.accountName} - ${(!accountDeviceSchedule.id ? "New Internet Schedule" : "Edit Internet Schedule")}`}
      onCancel={onCancel}
      onClose={onCancel}
      onSave={onSubmit}
    >
      { loading &&
        <Loader />
      }
      <view data-scroll=''>
        <group data-space="15" data-gap="10" data-direction="column">

          <group data-gap="10" >
            <OptionBar data-length="410">
              <Checkbox checkboxType={CheckboxType.Button} label="Mon" checked={dayIsActive('mon')} onChange={(e) => onDaySelectionChange(e, 'mon')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Tue" checked={dayIsActive('tue')} onChange={(e) => onDaySelectionChange(e, 'tue')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Wed" checked={dayIsActive('wed')} onChange={(e) => onDaySelectionChange(e, 'wed')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Thu" checked={dayIsActive('thu')} onChange={(e) => onDaySelectionChange(e, 'thu')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Fri" checked={dayIsActive('fri')} onChange={(e) => onDaySelectionChange(e, 'fri')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Sat" checked={dayIsActive('sat')} onChange={(e) => onDaySelectionChange(e, 'sat')} />
              <Checkbox checkboxType={CheckboxType.Button} label="Sun" checked={dayIsActive('sun')} onChange={(e) => onDaySelectionChange(e, 'sun')} />
            </OptionBar>
          </group>
          <group data-gap="10">
            <div className="field">
              <div data-position="left" className="data_label"><text data-weight="700">From Time</text></div>
              <AntTimePicker
                name="fromTime"
                //label="From Time"
                needConfirm={false}
                minuteStep={15}
                format="hh:mm a"
                value={ fromTime }
                onChange={ (t) => setFromTime(t) }
              />
            </div>
            <div className="field">
              <div data-position="left" className="data_label"><text data-weight="700">To Time</text></div>
              <AntTimePicker
                name="toTime"
                //label="To Time"
                needConfirm={false}
                minuteStep={15}
                format="hh:mm a"
                value={ toTime }
                onChange={ (t) => setToTime(t) }
              />
            </div>
          </group>
        </group>
      </view>
    </Popup>
  );
}
